import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-top",
  "use": "icon-arrow-top-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"icon-arrow-top\">\n<title>切片</title>\n<g id=\"icon-arrow-top_路径\">\n\t<polygon points=\"512,230.8 962,680.8 849.5,793.2 512,455.8 174.5,793.2 62,680.8 \t\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol